import clsx from "clsx";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section>
      <img
        src="/images/injera/logo.svg"
        alt="INJERA"
        className="w-auto h-10 sm:h-12 mx-auto mb-3 sm:mb-6"
      />
      <h1
        className={clsx(
          "mx-auto max-w-3xl font-extrabold text-3xl sm:text-5xl tracking-wide py-4 text-center",
          "text-white"
        )}>
        Creating A New Token Economy
      </h1>
      <div className="mx-auto mt-3 max-w-3xl text-base sm:text-lg text-slate-200 text-center">
        <div>High Yielding and Transparent Synthetic Dollar</div>
      </div>
      <div className="flex flex-col xs:flex-row justify-center gap-3 mt-12 max-w-sm mx-auto sm:max-w-max">
        <a
          id="connect"
          href="https://medium.com/@Injera/maximizing-your-gem-earnings-a-comprehensive-guide-to-injeras-gem-farming-in-phase-2-c0dea0e79d91"
          target="_blank"
          rel="noreferrer"
          className="font-bold text-white rounded-lg flex justify-center items-center relative h-8 tracking-wider duration-200 px-4 bg-transparent border border-slate-300 uppercase hover:opacity-80">
          LEARN MORE
        </a>
        <Link
          to="/join"
          className="font-bold text-black rounded-lg flex justify-center items-center relative h-8 tracking-wider duration-200 px-4 bg-white uppercase hover:opacity-80">
          Farm $GEMs Now
        </Link>
      </div>
    </section>
  );
};

export default Hero;
